export default {
      id: "pinterest-usage",
      viewBox: "0 0 511.977 511.977",
      url: "../../assets/" + "sprite.svg#pinterest-usage",
      toString: function () {
        return this.url;
      }
    }